export type ProductNoticeAudience = "parent" | "admin" | "all";
export type ProductNoticeTone = "attention" | "success";
export type ProductNoticeShell = "parent" | "admin";

export interface ProductNotice {
  id: string;
  message: string;
  tone: ProductNoticeTone;
  audience: ProductNoticeAudience;
  /** Hidden at and after this UTC instant. */
  visibleUntil: string;
}

/**
 * Code-only announcements. Add a new object with a new id when something ships.
 * audience: "parent" | "admin" | "all". A user who closes one does not hide the next.
 */
export const PRODUCT_NOTICES: ProductNotice[] = [
  {
    id: "ach-available-2026-10-21",
    audience: "parent",
    tone: "success",
    visibleUntil: "2026-10-25T07:00:00.000Z",
    message:
      "ACH is available. You can add a bank account as a payment method.",
  },
];

export function productNoticeShell(
  pathname: string | null | undefined,
): ProductNoticeShell | null {
  if (!pathname) return null;
  if (pathname.startsWith("/portal")) return "parent";
  if (pathname.startsWith("/admin")) return "admin";
  return null;
}

export function activeProductNotices(
  notices: readonly ProductNotice[],
  shell: ProductNoticeShell,
  now: Date,
  dismissedIds: ReadonlySet<string>,
): ProductNotice[] {
  return notices.filter((notice) => {
    if (dismissedIds.has(notice.id)) return false;
    if (notice.audience !== "all" && notice.audience !== shell) return false;
    const until = Date.parse(notice.visibleUntil);
    return !Number.isNaN(until) && now.getTime() < until;
  });
}
